import { render, staticRenderFns } from "./ColaboratorsSection.vue?vue&type=template&id=f5eb1554&"
import script from "./ColaboratorsSection.vue?vue&type=script&lang=js&"
export * from "./ColaboratorsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports